import React, { Fragment } from "react";
import Header from "../header/Header";
import PatientVisits from "../patient-visits/PatientVisits";
import Patients from "../patients/Patients";
export default function DashboardResearchIndiaInternal() {
  return (
    <Fragment>
      <Header />
      <PatientVisits category={"research"} study_type="INDIA_INTERNAL" />
      <Patients category={"research"} study_type="INDIA_INTERNAL" />
    </Fragment>
  );
}
